// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'
import scroll from 'vue-seamless-scroll'
import md5 from 'js-md5'
import './assets/iconfonts/iconfont.css'
// import HappyScroll from 'vue-happy-scroll'
import 'vue-happy-scroll/docs/happy-scroll.css'
import store from '@/store'
import { timers } from 'jquery'
// Vue.use(HappyScroll)

// import ApolloClient from 'apollo-client'
// import { authenticatedFetch } from '@shopify/app-bridge-utils'
// import createApp from '@shopify/app-bridge'
// import deepMerge from '@shopify/app-bridge/actions/merge'
// import { HttpLink } from 'apollo-link-http'
// import { InMemoryCache } from 'apollo-cache-inmemory'
// import { UrlSearch } from './components/utils/UrlSearch'

// const customFetchWrapper = (uri, options) => {
//   const aggregateOptions = deepMerge(options, {
//     method: 'post',
//     headers: { 'Content-Type': 'application/json' }
//   })
//   return fetch(uri, aggregateOptions)
// }
// const app = createApp({
//   apiKey: '4e8b394d07420fee4cb26baeeafe1ca9',
//   host: UrlSearch().host
// })
// console.log('11111')
// console.log(UrlSearch().host)
// const client = new ApolloClient({
//   link: new HttpLink({
//     credentials: 'same-origin',
//     fetch: authenticatedFetch(app, customFetchWrapper)
//   }),
//   cache: new InMemoryCache()
// })
// Vue.use(client)
// 将iframe地址参数存在vuex中，否则后续定时器取的地址不对
// https://appshopify.sendfromchina.com/?hmac=5883ba681ecb5d6dd122d97b954ae4365a747ca1d7e515a5bec49375ef67368f&host=YWxsZW5zaG93czIubXlzaG9waWZ5LmNvbS9hZG1pbg&locale=en&session=06ddea7fe7ec036396703bd717af81c5e2a45af3a30207cd7dae17e853f4ba1e&shop=allenshows2.myshopify.com&timestamp=1630466833

// function UrlSearch () {
//   let name, value, str = location.href, num = str.indexOf('?') // 取得整个地址栏
//   console.log(str)
//   var install = str.indexOf('install')
//   var play = str.indexOf('rechargeOrder')

//   var surl = {install: install, play: play}
//   if (play > 0) {
//     if (str.indexOf('orderId') > 0) {
//       let order = str.lastIndexOf('orderId/'); let orderId = str.lastIndexOf('\/')
//       surl.orderId = str.substring(order + 8, orderId)
//     }
//   }
//   str = str.substr(num + 1) // 取得所有参数 stringvar.substr(start [, length ]
//   let arr = str.split('&') // 各个参数放到数组里
//   let UrlSearch = new Array()

//   UrlSearch.push(surl)
//   for (let i = 0; i < arr.length; i++) {
//     num = arr[i].indexOf('=')

//     if (num > 0) {
//       name = arr[i].substring(0, num)
//       value = arr[i].substr(num + 1)
//       // this[name]=value;
//       surl[name] = value
//     }
//   }
//   UrlSearch.push(surl)
//   console.log('11', UrlSearch[0])
//   store.dispatch('setHref', UrlSearch[0])
//   return UrlSearch[0]
// }
// UrlSearch()
// function aaa () {
//   console.log('第一')
//   var AppBridge = window['app-bridge']
//   var createApp = AppBridge.default
//   var getSessionToken = window['app-bridge-utils'].getSessionToken
//   var app = createApp({
//     apiKey: '4e8b394d07420fee4cb26baeeafe1ca9', // 测试
//     // apiKey: '9bd8c37989642e52c90714a8d713b903', // 正式
//     shopOrigin: store.getters.urlSearch ? store.getters.urlSearch.shop : UrlSearch().shop
//   })

//   getSessionToken(app).then(session_token => getPageContent(session_token)).catch(err => {
//     alert('App authentication failed, try refreshing the page')
//     console.log(err)
//   })

//   function getPageContent (session_token) {
//     store.dispatch('setToken', session_token)
//     console.log('token:', store.getters.token)
//     // if (window.thisComponent) {
//     //   window.thisComponent.sMacAddr = 'Bearer ' + session_token
//     // }
//     //   fetch('{{ url_behind_session_token_auth }}', {
//     //       headers: new Headers({
//     //           'Authorization': 'Bearer ' + session_token
//     //       })
//     //   }).then(data => data.json()).then(json => {
//     //       //do stuff
//     //       console.error(json);
//     //   });
//   }
// }
// aaa()
// const timer = function () {
//   setInterval(() => {
//     aaa()
//   }, 30000)
// }
// timer()

Vue.use(ElementUI, { locale }, scroll)
Vue.prototype.$md5 = md5
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js